import React, { FC, useState } from "react";

import { AttentionBanner, Icon } from "../../common";
import { NewWalletModal } from "../../modals";
import { toastSuccess } from "../../../utils/toasts";

export const AddWalletBanner: FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="w-[340px] h-[244px]">
      <AttentionBanner
        heading={
          <div className="flex items-center gap-4">
            <Icon icon="Wallet" size={24} />
            Add wallet
          </div>
        }
        action={{
          label: "Add",
          onClick: () => setShowModal(true),
        }}
      >
        Get money from clients to your preferred wallet in a minutes
      </AttentionBanner>

      {showModal && (
        <NewWalletModal
          isOpen={showModal}
          close={() => setShowModal(false)}
          callback={() => {
            toastSuccess("Wallet created successfully");
            setShowModal(false);
          }}
        />
      )}
    </div>
  );
};
